"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168,
    height: 148,
    "aria-labelledby": "loading",
    className: "uil-ring-alt",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 100 100"
  }, props), /*#__PURE__*/React.createElement("title", null, "Loading..."), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h100v100H0z",
    className: "bk"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 40,
    fill: "none",
    stroke: "#fefefe",
    strokeLinecap: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 40,
    fill: "none",
    stroke: "#95e2f5",
    strokeLinecap: "round",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    dur: "2s",
    from: 0,
    repeatCount: "indefinite",
    to: 502
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    dur: "2s",
    repeatCount: "indefinite",
    values: "150.6 100.4;1 250;150.6 100.4"
  })));
};
var _default = exports.default = SvgComponent;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');